export default class NetworkInvitationAPIRequest {
    recipientId?: string;
    message?: string;
}
